import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { customer_login, messageClear } from '../store/reducers/authReducer';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer'
import { toast } from 'react-hot-toast';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Eye, EyeOff, LoaderIcon } from "lucide-react";

const Login = () => {
  const { loader, successMessage, errorMessage, userInfo } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [state, setState] = useState({
    email: '',
    password: ''
  });

  const [showPassword, setShowPassword] = useState(false);

  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value
    });
  };

  const login = (e) => {
    e.preventDefault();
    if (!state.email || !state.password) {
      toast.error("Email and password are required!");
      return;
    }
    dispatch(customer_login(state));
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
    if (userInfo) {
      navigate('/');
    }
    document.documentElement.classList.add('login-page');

    // Remove the class when the component unmounts
    return () => {
      document.documentElement.classList.remove('login-page');
    };
  }, [successMessage, errorMessage, userInfo, dispatch, navigate]);

  return (
    <>
    <div className="p-4 flex flex-col items-start max-w-sm mx-auto h-dvh overflow-hidden pt-20 mb-20">
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-background/80 z-50">
          <LoaderIcon className="w-5 h-5 animate-spin" />
        </div>
      )}
     
      <div className="flex items-center w-full py-8 border-b border-border/80">
        <Link to="/" className="flex items-center">
          <img
            src={`${process.env.REACT_APP_URL}/images/omahlogoupdated.png`}
            alt="Omah Global"
            className="h-8 w-auto object-contain"
          />
        </Link>
      </div>

      <div className="flex flex-col items-start gap-y-6 py-8 w-full px-0.5">
        <div className="w-full">
          <h2 className="text-2xl font-semibold">
            Sign in to Omah Global
          </h2>
          <p className="text-sm text-muted-foreground mt-2">
            Customer portal - 
            <a href={`${process.env.REACT_APP_SELLER_DASHBOARD_URL}/login`} className="text-primary hover:underline ml-1">
              Merchant? Sign in here
            </a>
          </p>
        </div>
        <form onSubmit={login} className="w-full">
          <div className="space-y-2 w-full">
            <Label htmlFor="email">
              Email
            </Label>
            <Input
              id="email"
              name="email"
              type="email"
              value={state.email}
              disabled={loader}
              onChange={inputHandle}
              placeholder="Enter your email"
              className="w-full focus-visible:border-foreground"
            />
          </div>

          <div className="mt-4 space-y-2">
            <Label htmlFor="password">
              Password
            </Label>
            <div className="relative w-full">
              <Input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={state.password}
                disabled={loader}
                onChange={inputHandle}
                placeholder="Enter your password"
                className="w-full focus-visible:border-foreground"
              />
              <Button
                type="button"
                size="icon"
                variant="ghost"
                disabled={loader}
                className="absolute top-1 right-1 rounded-md"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? 
                  <EyeOff className="w-4 h-4" /> : 
                  <Eye className="w-4 h-4" />
                }
              </Button>
            </div>
          </div>

          <div className="mt-4 w-full">
            <Button
              type="submit"
              disabled={loader}
              className="w-full"
            >
              {loader ? (
                <LoaderIcon className="w-5 h-5 animate-spin" />
              ) : "Continue"}
            </Button>
          </div>
        </form>
      </div>

      <div className="flex flex-col items-start w-full mt-4">
        <p className="text-sm text-muted-foreground">
          Forgot password? {" "}
          <Link to="/forgotpassword" className="text-primary">
           Reset password
          </Link>{" "}
        
        </p>
      </div>

      <div className="flex items-start mt-auto border-t border-border/80 py-6 w-full">
        <p className="text-sm text-muted-foreground">
          Don&apos;t have an account?{" "}
          <Link to="/register" className="text-primary">
            Sign up
          </Link>
        </p>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default Login;